module.exports = __webpack_public_path__ + "scripts/info.svg?ba56d319";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info.svg
// module id = 920
// module chunks = 1